// Mirrors core's AcceptedTermsContext / ConsentMethod enums, serialised camelCase-first-letter
// on the wire. Unknown values still render (the label falls back to the raw key), so a new core
// enum member can ship before this list catches up.
export const consentContext = {
  grassrootzTerms: 'grassrootzTerms',
  customCampaignTerms: 'customCampaignTerms',
  customEventAmbassadorTerms: 'customEventAmbassadorTerms',
  customCampaignAmbassadorTerms: 'customCampaignAmbassadorTerms',
  customCampaignAmbassadorDonationPlanTerms:
    'customCampaignAmbassadorDonationPlanTerms',
  privacyPolicy: 'privacyPolicy',
  ageConfirmation: 'ageConfirmation',
  marketingOptIn: 'marketingOptIn',
  cookieConsent: 'cookieConsent',
  registrationFeeTerms: 'registrationFeeTerms'
} as const;
export type ConsentContext =
  (typeof consentContext)[keyof typeof consentContext];

export const consentMethod = {
  unknown: 'unknown',
  ambassadorApplication: 'ambassadorApplication',
  signUp: 'signUp',
  pageCreation: 'pageCreation',
  reAcceptancePrompt: 'reAcceptancePrompt',
  integration: 'integration',
  cookieBanner: 'cookieBanner',
  inviteActivation: 'inviteActivation',
  donation: 'donation',
  ticketPurchase: 'ticketPurchase'
} as const;
export type ConsentMethod = (typeof consentMethod)[keyof typeof consentMethod];

export interface ConsentDocumentVersion {
  context: ConsentContext;
  effectiveAt: string;
  id: number;
  requiresReAcceptance: boolean;
  url: string | null;
  version: string;
}

// The registration fee wording and values an applicant agreed to.
export interface RegistrationFeeVersion {
  amount: number;
  createdAt: string;
  currency: string;
  id: number;
  nonRefundable: boolean;
  terms: string;
}

export interface ConsentEvent {
  // Null: the platform recorded that nobody asked (a page created by a partner or an admin).
  accepted: boolean | null;
  campaignId: number | null;
  campaignName: string | null;
  context: ConsentContext;
  createdAt: string;
  documentVersion: ConsentDocumentVersion | null;
  explicitlyAccepted: boolean;
  id: number;
  ipAddress: string | null;
  method: ConsentMethod;
  organizationId: number | null;
  organizationName: string | null;
  payload: string | null;
  registrationFeeVersion: RegistrationFeeVersion | null;
}
